// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.flow-canvas-container {
  background-color: #0b0f1c;
  background-image: radial-gradient(#00f0ff22 1px, transparent 1px);
  background-size: 20px 20px;
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/FlowBuilderConfig/flowbuilder.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;EACzB,iEAAiE;EACjE,0BAA0B;EAC1B,WAAW;EACX,YAAY;AACd","sourcesContent":["\n.flow-canvas-container {\n  background-color: #0b0f1c;\n  background-image: radial-gradient(#00f0ff22 1px, transparent 1px);\n  background-size: 20px 20px;\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
